/* 周瑜傳・第 3 章上半：南郡（上）・夷陵解圍（建安十三年，208）
 * 史實：《三國志·周瑜傳》「瑜即遣甘寧前據夷陵。仁分兵騎別攻圍寧。寧告急於瑜。瑜用呂蒙計，留淩統以守其後，身與蒙上救寧。」
 *       《呂蒙傳》：「蒙謂瑜、普曰：『留凌公績，蒙與君行，解圍釋急，勢亦不久，蒙保公績能十日守也。』又說瑜分遣三百人柴斷險道，
 *       賊走可得其馬。瑜從之。軍到夷陵，即日交戰，所殺過半。敵夜遁去，行遇柴道，騎皆捨馬步走。兵追蹙擊，獲馬三百匹，方船載還。」
 *       《甘寧傳》：「曹仁乃令五六千人圍寧。寧受攻累日，敵設高樓，雨射城中，士衆皆懼，惟寧談笑自若。」
 * 流程：周瑜、呂蒙在東南的江岸上岸。凌統在江陵前線守後方，只撐得了「十日」（倒數）。
 *       先往北到三條險道的山口伐柴斷道（站著讀條，可以不做，但敵人夜遁時沒斷的路就讓騎兵帶著馬跑了）→
 *       燒掉圍城的三座高樓（高樓一直往城裡放箭，甘寧會被射傷）；殺敵過半 → 入夜，曹軍騎兵往北面的險道逃（騎著馬追不上）：
 *       撞上柴道的就捨馬步走（繳獲馬匹，人也追得上），沒斷的路就讓他們帶著馬跑了→ 寧圍既解，接第二幕「擽陣・自興」。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, ally, allyTick, TROOPS } from '../kit.ts';
import { tower, chai, walkTo } from './zhouyu_kit.ts';
import { CITY, LAND, PASSES, EXIT_Y, TOWERS, SIEGE } from '../maps/zhouyu_yiling.ts';

const LV = 12, TEN = 330, DAY = TEN / 10, CUT_T = 2.5, BURN_T = 2;
const RIDER = { spec: TROOPS.wei, name: '曹騎', hp: 600, maxHp: 600, atk: 30, ms: 250 };
const HORSES = 30; // 一名騎兵棄下的馬（遊戲裡一人算三十匹）

export default {
  id: 'zhouyu-3', map: 'zhouyu_yiling', hero: 'zhouyu',
  next: 'zhouyu-3b', // 第二幕：擽陣・自興（評星在第二幕）
  title: '第 3 章　南郡（上）・夷陵解圍', year: '建安十三年（208）',
  brief: {
    quote: [{ text: '又說瑜分遣三百人柴斷險道，賊走可得其馬。瑜從之。', src: '《三國志·吳書·呂蒙傳》' }],
    text: '赤壁戰後，曹操北還，留曹仁守江陵。周瑜、程普進到南郡，和曹仁隔江相對。周瑜派甘寧先去佔據夷陵，曹仁分兵把夷陵圍住。甘寧告急。呂蒙獻計：留凌統守後方，周瑜和呂蒙親自去救；再派人砍柴堵住敵人退走的險道。',
    goals: ['（可選）到北邊三處山口伐柴斷道', '燒掉圍城的高樓，別讓甘寧被射倒', '殺敵過半', '敵人夜遁：堵在柴道上的騎兵會棄馬', '凌統只能守十日'],
  },
  words: { ally: '吳兵', foe: '曹軍' },
  steps: [
    { // 0. 柴斷險道、解圍
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = LAND[0]; me.y = LAND[1];
        V.t0 = w.t; V.cut = [false, false, false]; V.horses = 0; V.escaped = 0; V.dismount = 0;
        V.lm = ally(w, 'lvmeng', LAND[0] - 120, LAND[1] + 60, LV);
        V.men = Array.from({ length: 8 }, (_, i) => { const u = m.recruit(LAND[0] - 160 - (i % 4) * 45, LAND[1] - 80 + Math.floor(i / 4) * 90, '吳兵'); m.join(u, me); return u; });
        // 城裡：甘寧與數百兵
        V.gn = ally(w, 'ganning', CITY.x - 60, CITY.y, LV);
        V.gn.hold = [CITY.x - 60, CITY.y]; V.gn.maxHp += 1800; V.gn.hp = V.gn.maxHp;
        V.inner = Array.from({ length: 5 }, (_, i) => { const u = m.recruit(CITY.x - 200 + i * 100, CITY.y + 120, '甘寧兵'); u.home = [u.x, u.y]; return u; });
        // 曹仁分兵：三營騎兵各帶一名營將；三座高樓
        V.foes = [];
        SIEGE.forEach(([x, y], k) => {
          for (let i = 0; i < 8; i++) { const a = (i / 8) * Math.PI * 2; V.foes.push(m.foe('huangjin', x + Math.cos(a) * 220, y + Math.sin(a) * 150, RIDER)); }
          V.foes.push(m.foe('bandit', x, y, { spec: TROOPS.wei, name: '曹軍營將', hp: 1400, maxHp: 1400, atk: 38 }));
        });
        V.n0 = V.foes.length;
        V.towers = TOWERS.map(([x, y], k) => { const f = m.folk(x, y, { name: '高樓', still: true, near: 1, draw: tower, fire: 0, burnt: false }); m.mark('t' + k, x, y, '高樓', true); return f; });
        V.chai = [];
        PASSES.forEach(([x, y], k) => m.mark('p' + k, x, y + 120, '險道', true));
        m.card('瑜用呂蒙計，留淩統以守其後，身與蒙上救寧。', '《周瑜傳》');
        m.line('呂蒙', '公績能守十日。趁這十日解圍——還有，北邊的三條險道，派人砍柴堵住，賊走了馬就是我們的。');
        m.after(6, () => m.line('提示', '到北邊山口（「險道」）站著不動，就會伐柴斷道。高樓旁邊站著不動可以放火燒樓。'));
        m.after(12, () => m.line('甘寧', '（城頭上）高樓射得再兇，也射不到我的酒杯。'));
        m.obj('ten', '');
        m.obj('cut', '（可選）柴斷險道', 3);
        m.obj('tower', '燒掉圍城的高樓（高樓一直往城裡射箭）', 3);
        m.obj('kill', '殺敵過半', Math.ceil(V.n0 / 2));
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars;
        // 伐柴斷道
        PASSES.forEach(([x, y], k) => {
          if (V.cut[k]) return;
          m.chanAt(me, 'cut' + k, x, y + 120, 170, CUT_T, '伐柴斷道', () => {
            V.cut[k] = true; m.unmark('p' + k);
            V.chai.push(m.folk(x, y + 40, { name: '柴道', still: true, near: 1, draw: chai }));
            m.prog('cut', V.cut.filter(Boolean).length);
            m.line('吳兵', ['西邊的險道堵住了！', '中間的險道堵住了！', '東邊的險道堵住了！'][k]);
          });
        });
        // 燒高樓：旁邊站著不動
        V.towers.forEach((f, k) => {
          if (f.burnt) return;
          m.chanAt(me, 'burn' + k, f.x, f.y + 60, 160, BURN_T, '燒高樓', () => {
            f.fire = 1; m.unmark('t' + k); w.fx({ k: 'boom', x: f.x, y: f.y - 80, r: 120, col: '#e8541c' });
            m.after(3, () => { f.fire = 0; f.burnt = true; });
            f.burnt = 'fire';
            m.prog('tower', V.towers.filter((t) => t.burnt).length);
          });
        });
        // 高樓雨射城中
        V.rainT = (V.rainT || 3) - dt;
        if (V.rainT <= 0) {
          V.rainT = 2.6;
          for (const f of V.towers) if (!f.burnt) m.strike(CITY.x + (SG.rand() - 0.5) * 600, CITY.y + (SG.rand() - 0.5) * 380, 120, 1.2, 70, 0);
        }
        const slain = V.foes.filter((u) => !u.alive).length;
        m.prog('kill', slain);
        return slain >= Math.ceil(V.n0 / 2); // 所殺過半，敵夜遁去
      },
    },
    { // 1. 敵夜遁去，行遇柴道
      enter(m, w) {
        const V = m.vars;
        V.night = true;
        m.done('kill'); if (V.towers.every((f) => f.burnt)) m.done('tower'); else m.drop('tower');
        m.card('軍到夷陵，即日交戰，所殺過半。敵夜遁去。', '《呂蒙傳》');
        V.flee = V.foes.filter((u) => u.alive);
        for (const u of V.flee) {
          let k = 0, bd = 1e9; PASSES.forEach(([x, y], i) => { const d = SG.gd(u.x, u.y, x, y); if (d < bd) { bd = d; k = i; } });
          u.pass = k; u.leg = 0; u.ms = 320; u.untargetable = true; walkTo(u, PASSES[k][0], PASSES[k][1] + 60); // 騎著馬趁夜跑：追不上
        }
        m.line('呂蒙', '他們要從北邊的險道跑！');
        m.obj('chase', '兵追蹙擊：追擊棄馬的曹兵');
      },
      tick(m, w) {
        const V = m.vars;
        for (const u of V.flee) {
          if (!u.alive || u.gone) continue;
          const [px, py] = PASSES[u.pass];
          if (u.leg === 0) {
            walkTo(u, px, py + 60);
            if (SG.gd(u.x, u.y, px, py + 60) < 160) {
              if (V.cut[u.pass]) { // 行遇柴道，騎皆捨馬步走
                u.leg = 1; V.dismount++; V.horses += HORSES;
                Object.assign(u, { name: '曹兵（棄馬）', ms: 150, untargetable: false });
                w.dmgEvents.push({ x: u.x, y: u.y - 60, text: `棄馬！+${HORSES} 匹`, team: 0, src: w.player.id });
                if (V.dismount === 1) m.line('吳兵', '撞上柴道了！他們下馬了，馬都留下來了！');
                u.home = [px + (SG.rand() - 0.5) * 300, py + 260]; u.think = 99;
                m.after(4, () => { if (u.alive) walkTo(u, px, EXIT_Y); });
              } else { u.leg = 2; walkTo(u, px, EXIT_Y); }
            }
          } else if (u.leg === 1 && u.home[1] === EXIT_Y && u.y < EXIT_Y + 120) { u.gone = true; u.alive = false; u.counted = true; V.escaped++; }
          else if (u.leg === 2 && u.y < EXIT_Y + 120) { u.gone = true; u.alive = false; u.counted = true; V.escaped++; V.lostHorse = (V.lostHorse || 0) + 1; }
        }
        m.get('chase').text = `兵追蹙擊：繳獲馬 ${V.horses} 匹`;
        return V.flee.every((u) => !u.alive);
      },
    },
    { // 2. 寧圍既解
      enter(m, w) {
        const V = m.vars;
        V.night = false; V.cutAll = V.cut.every(Boolean); V.leftDays = Math.max(0, Math.ceil((TEN - (w.t - V.t0)) / DAY));
        m.done('chase');
        m.card(V.horses ? `兵追蹙擊，獲馬${V.horses >= 300 ? '三百' : ` ${V.horses} `}匹，方船載還。` : '敵騎都帶著馬跑了。', '《呂蒙傳》');
        m.after(5, () => m.line('甘寧', '公瑾來得正好，酒還溫著。'));
        m.after(9, () => m.card('寧圍既解，乃渡屯北岸，剋期大戰。', '《周瑜傳》'));
        m.after(14, () => m.win());
      },
      tick() { return false; },
    },
  ],
  always(m, w) {
    const me = w.player, V = m.vars;
    if (!me.alive) { m.lose('周瑜陣亡'); return; }
    if (V.gn && !V.gn.alive) { m.lose('甘寧陣亡，夷陵失守'); return; }
    if (V.lm) { allyTick(w, V.lm, me); allyTick(w, V.gn, null, 420); }
    if (V.t0 != null && m.i < 2) {
      const left = TEN - (w.t - V.t0);
      m.get('ten').text = `凌統守後：還能撐 ${Math.max(0, Math.ceil(left / DAY))} 日`;
      if (left <= 0) m.lose('十日已過，凌統守不住了');
    }
  },
  overlay(ctx, m, view, x0, y0, vw, vh) {
    if (!m.vars.night) return;
    ctx.fillStyle = 'rgba(12,18,48,.45)'; ctx.fillRect(x0, y0, vw, vh);
  },
};
